import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { onINP } from 'web-vitals/attribution';
import { AuthenticationService } from './authentication.service';



@Injectable({providedIn: 'root'})
export class RUMService {

  private awsRum: any;

  constructor(private authService: AuthenticationService) {
        
  }
  
  async initRUM() {
    try {
      const { AwsRum } = await import('aws-rum-web');
      this.awsRum = new AwsRum(
        environment.awsRUM.applicationId,
        environment.awsRUM.applicationVersion,
        environment.awsRUM.applicationRegion,
        environment.awsRUM.config
      );
    } catch (e) {
      console.error("Failed to init AWS RUM ", e);
    }
    
    onINP((metric) => {
      const threshold = 200; // Customize this threshold as needed

      if (metric.value > threshold && metric.entries.length > 0) {
        const interaction = metric.entries[0];
        const targetNode = interaction.target;
        const targetHtml = (targetNode instanceof Element) ? targetNode.outerHTML : undefined;

        const source = {
          name: interaction.name,
          target: targetHtml,
          type: interaction.entryType,
          startTime: interaction.startTime,
          duration: interaction.duration,
          loggedIn: this.authService.isAuthenticated(),
          attribution: metric.attribution  // Include full attribution object
        };

        // Send to AWS RUM
        if (this.awsRum.recordEvent) {
          this.awsRum.recordEvent('longINP', {
            value: metric.value,
            interaction: source
          });
        }
      }
    }, { reportAllChanges: true });
  }
  
  handleError(error: any) {
    this.awsRum?.recordError(error);
  }
  
  
}

  